import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, StatusWarning } from '_components';
import styles from './Common.module.css';


class AlTemplateOtherRow extends React.Component {

    render() {
        return (
            <div className={styles.row}>
                <CheckBox
                    size='extra-small'
                    className={styles.checkbox}
                    checked={this.props.activity.selected}
                    title={this.props.desc}
                    label={this.props.desc}
                    onClick={() => this.props.toggleItem({ entity: 'MLTMPOTHERALITIES', entityKeyColumn: 'XLTMPOENO', entityKeyValue: this.props.activity.XLTMPOENO })}
                />
                { !this.props.activity.valid &&
                    <span className={styles.warning}>
                        <StatusWarning size='extra-small' title='Not Reimbursable based on Payer/Contract' />
                    </span>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        toggleItem: bindActionCreators(noteActions.alTemplateToggleItem, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let activity = state.entities.notes.MLTMPOTHERALITIES[ownprops.id];
    let mdname = activity.XLTMPOEOENO ? state.entities.masterData.MLMASTEROTHERALITIESASSDEV[activity.XLTMPOEOENO].OENAME + ' - ' : '';
    let act = activity.XLTMPOEACTIVITY ? activity.XLTMPOEACTIVITY + ' - ' : '';
    let time = activity.XLTMPOETIME ? activity.XLTMPOETIME + ' min - ' : '';
    let desc = mdname + act + time;
    desc = desc.endsWith(' - ') ? desc.slice(0, -3) : desc;

    return {
        noteId: noteId,
        activity: activity,
        desc: desc
    };
}

const connectedAlTemplateOtherRow = connect(mapStateToProps, mapDispatchToProps)(AlTemplateOtherRow);
export { connectedAlTemplateOtherRow as AlTemplateOtherRow };

